export default "__VITE_ASSET__Ps0H_Jra__"